export default "__VITE_ASSET__Cv5G54pG__"